import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import BroadcastScreen from './broadcast/BroadcastScreen';
import { ThemeProvider } from './design/ThemeProvider';
import './design/tokens.css';
import '@livekit/components-styles';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ThemeProvider>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/broadcast" element={<BroadcastScreen />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
);
